<template>
  <img src="~/assets/icon/icon-mail.svg" />
</template>
